class ConfirmModal extends HTMLElement {
  static getOpenModal() {
    return document.querySelector("confirm-modal[open]");
  }

  constructor() {
    super();
    this.debug = this.getAttribute("data-debug");
    this.id = this.getAttribute("id");
    this.show = parseInt(this.getAttribute("data-show"));

    this.isOpen = false;

    this.style.setProperty("display", "none");

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this),
    );

    const self = this;

    this.tryToOpen();
  }

  open() {
    this.setStorage();
    this.style.removeProperty("display");
    if (this.isOpen) {
      return;
    }
    this.isOpen = true;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    trapFocus(this, this.querySelector(".modal-content"));
    // window.pauseAllMedia();
    document.querySelectorAll("auto-modal[open]").forEach((autoModal) => {
      autoModal.hide();
    });
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "CONFIRM-MODAL") this.hide();
    });
  }

  hide() {
    this.isOpen = false;
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    // window.pauseAllMedia();
    document.querySelectorAll("auto-modal[open]").forEach((autoModal) => {
      autoModal.hide();
    });

    setTimeout(() => {
      this.style.setProperty("display", "none");
    }, 1000);
  }

  tryToOpen() {
    const now = new Date();

    const params = new URLSearchParams(window.location.search);
    if (params.has("openConfirmPopup")) {
      this.open();
      return;
    }
    if (params.has("customer_posted")) {
      const alreadyOpenConfirm = ConfirmModal.getOpenModal();
      if (alreadyOpenConfirm && alreadyOpenConfirm !== this) {
        return;
      }

      const targetId = window.sessionStorage.getItem("confirm-modal-target");
      if (targetId && this.id !== targetId) {
        return;
      }

      if (
        !localStorage.getItem(this.id + "-confirm") ||
        parseInt(localStorage.getItem(this.id + "-confirm")) <= now.getTime()
      ) {
        this.open();
      }

      if (targetId && this.id === targetId) {
        window.sessionStorage.removeItem("confirm-modal-target");
      }
      return;
    }
    if (this.debug) {
      this.open();
    }
  }

  setStorage() {
    //We want to hide the signup popup as well
    const now = new Date();
    localStorage.setItem(this.id, now.getTime() + this.show * 60 * 60 * 1000);
    localStorage.setItem(
      this.id + "-confirm",
      now.getTime() + this.show * 60 * 60 * 1000,
    );
  }
}
customElements.define('confirm-modal', ConfirmModal);
